import $ from 'jquery';
import BaseSettings from './base-settings';
import {registerSettings} from "./register";
import Modal from '../client/threeds-modal';

class CreditCardSettings extends BaseSettings {

    constructor(props) {
        super(props);
        this.initialize();
    }

    initialize() {
        $(document.body).on('click', '.show3DSModal', this.onShow3DSModal.bind(this));
        $(document.body).on('wc_ppcp_3ds_config_change', this.on3DSConfigChange.bind(this));
        $(document.body).on('wc_ppcp_card_settings_save', this.onSave.bind(this));
        $(document.body).on('wc_ppcp_3ds_config_reset', this.on3DSConfigReset.bind(this));
    }

    onSave() {
        $('.woocommerce-save-button').prop('disabled', false);
        $('.woocommerce-save-button').trigger('click');
    }

    onShow3DSModal(e) {
        e.preventDefault();
        const value = $(`[name^="${this.prefix}3ds_config"]`).serializeArray().map(({name, value}) => {
            const key = $(`[name="${name}"]`).data('key');
            const defaultValue = $(`[name="${name}"]`).data('default');
            return {key, value, default_value: defaultValue};
        });
        Modal.render(document.getElementById('3ds-app'), {value, i18n: this.data.i18n});
    }

    on3DSConfigChange(e, data) {
        const {key, value} = data;
        // update the hidden input field.
        $(`[name="${this.prefix}3ds_config[${key}]"]`).val(value);
    }

    on3DSConfigReset() {
        $(`[name^="${this.prefix}3ds_config"]`).serializeArray().map(({name, value}) => {
            const defaultValue = $(`[name="${name}"]`).data('default');
            $(`[name="${name}"]`).val(defaultValue);
        });
    }
}

registerSettings('ppcp_card', CreditCardSettings);